import { environment } from './environment';


export const ConfigMasterEnvironment = {
  environment: environment
};
